// libs
import React, { memo, Children, useMemo } from 'react';
// styles
import styles from './SummaryTable.module.scss';
const Row = ({ children, widths = [] }) => {
    const fixedWidths = useMemo(() => {
        const noOfChildren = Children.count(children);
        if (noOfChildren === 0) {
            return [];
        }
        if (widths.length === noOfChildren) {
            return widths;
        }
        if (widths.length > noOfChildren) {
            return widths.slice(0, noOfChildren);
        }
        if (widths.length < noOfChildren) {
            const newWidths = [...widths];
            const lengthDiff = noOfChildren - widths.length;
            const widthDiff = 100 - widths.reduce((acc, curr) => acc + curr, 0);
            if (widthDiff < 0) {
                throw new Error('No of children exceeds 100% width');
            }
            const lastWidth = widthDiff / lengthDiff;
            for (let i = 0; i < lengthDiff; i++) {
                newWidths.push(lastWidth);
            }
            return newWidths;
        }
        return widths;
    }, [widths, children]);
    return (React.createElement("tr", { className: styles.tableRow }, Children.toArray(children).map((child, index) => {
        return (React.createElement("td", { style: {
                flexBasis: `${fixedWidths[index]}%`,
                flexGrow: 0,
                flexShrink: 0,
            }, key: index }, child));
    })));
};
export default memo(Row);
